import app from 'flarum/forum/app';
import addSpeciesToolsMenu from './addSpeciesToolsMenu';
import addSpeciesMenu from './addSpeciesMenu';
import addHomeDescriptions from './addHomeDescriptions';
import addSpeciesSearch from './addSpeciesSearch';
import addSpeciesLabels from './addSpeciesLabels';
import addSpeciesControl from './addSpeciesControl';
import addSpeciesComposer from './addSpeciesComposer';
import addSpeciesDiscussionForum from './addSpeciesDiscussionForum';
import addDataSourceSetting from './addDataSourceSetting';
import addDiscussionSpeciesUrl from './addDiscussionSpeciesUrl';
import addMissingSpeciesSort from './addMissingSpeciesSort';
export { default as extend } from './extend';
app.initializers.add('champis-species', () => {
  addSpeciesToolsMenu();
  addSpeciesMenu();
  addHomeDescriptions();
  addSpeciesSearch();
  addSpeciesLabels();
  addSpeciesControl();
  addSpeciesComposer();
  addSpeciesDiscussionForum();
  addDataSourceSetting();
  addDiscussionSpeciesUrl();
  addMissingSpeciesSort();
});